export const DirectTabLoader = (windowName, ssoUrls) => {
    const wn = windowName
    try {
        window.open(ssoUrls, wn).focus();
    } catch (error) {    
        window.location.href = ssoUrls;
    }
}